import { h } from 'preact';
import * as BaseComp from 'components/bolt/landscapeOverlay/landscapeOverlay.js';
import { quizCopy } from 'helpers/quizCopy';
import Store from 'store/store';
import s from 'components/bolt/landscapeOverlay/landscapeOverlay.sss';

export default class LandscapeOverlay extends BaseComp.default {
	componentDidMount() {
		Store.emit('TRACK_QUIZ_VIEW', 'rotate-device');
	}

	render() {
		const imageRoot = Store.get()?.appData?.urls?.roots?.image || '';
		return (
			<div class={s.wrapper}>
				<img class={s.phone} src={`${imageRoot}/rotate-device.png`} />
				<p class={s.message}>
					{quizCopy.$turnDevice}
					<span>{quizCopy.$portraitMode}</span>
				</p>
			</div>
		);
	}
}
